import { createTheme } from '@mui/material/styles';
import palette from './palette';
import typography from './typography'
import boxStyles from './box';

const theme = createTheme({
    palette,
    typography,
    // shadows,
    shape: {
        borderRadius: 8,
    },
    boxStyles
    // components
})

export default theme